<script>
	import { elasticOut, backIn } from 'eases-jsnext';
	import { fade, fly } from 'svelte/transition';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
	export let cta = false;
	export let salepop = false;
	export let mstep = 1;
	export let muted = false;
	export let lang;
	export let saved;

	function checkMute() {
		if (muted) {
			// todo Add a function for when they can't close with a background overlay click
		} else {
			dispatch("close");
		}
	}
</script>

<style>
	.modal-background {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.3);
		animation: reveal .5s ease 1;
		z-index: 12;
	}
	@keyframes reveal {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	.modal {
		position: fixed;
		left: 50%;
		top: 21%;
		width: 80%;
		max-width: 500px;
		max-height: calc(100vh - 4em);
		overflow: auto;
		transform: translateX(-50%);
		padding: 1.2rem;
		border-radius: 0.75rem;
		background: white;
		z-index: 13;
	}

	button {
		border-radius: 0.5rem;
    background: #efefef;
    border: 0;
    cursor: pointer;
    padding: 0.75rem;
    margin: 0;
    transition: all .3s ease;
    display: grid;
    align-content: center;
    font-weight: 600;
    color: #464655;
	}
	button:hover {
		background: #c4c4c4;
	}
	.button-grid {
		display: flex;
		flex-wrap: wrap;
	}
	.main-cta {
		background: #FFB961;
		margin-right: 20px;
		transition: all .3s ease;
	}
	.main-cta:hover {
		background: #fec988;
	}
	.beef-cta {
		background: #90E1BD;
		margin-right: 20px;
		transition: all .3s ease;
	}
	.beef-cta:hover {
		background: #a0f1cd;
	}
	.sweet-cta {
		background: #FFB961;
		transition: all .3s ease;
	}
	.sweet-cta:hover {
		background: #fec988;
	}
	.country-btn {
		background: #f4f4f4;
		border-radius: 100px;
		display: flex;
		padding: 5px;
		align-items: center;
		margin-bottom: 15px;
    margin-right: 15px;
	}
	.country-btn span {
		width: 130px;
		text-align: center;
	}
	.country-img {
		width: 40px;
		height: auto;
	}
	.success-cta {
		background: #92E1BE;
		transition: all .3s ease;
		margin-right: 20px;
	}
	.success-cta:hover {
		background: #b3f4d7;
	}
	.secondary-cta {
		background: #fff;
		transition: all .3s ease;
		color: #b25959;
	}
	.secondary-cta:hover {
		background: #efefef;
	}
	small {
		background: #efefef;
    display: block;
    border-radius: .5rem;
    padding: 7px;
    margin-top: 20px;
	}
	.email-us {
		color: #598cd8;
    font-weight: bold;
    letter-spacing: 1px;
	}
</style>

<div class='modal-background' on:click='{checkMute}' out:fade="{{ duration: 500, delay: 0 }}"></div>

<div class='modal' in:fly="{{ y: 50, duration: 1000, delay: 75, easing: elasticOut }}" out:fly="{{ y: 50, duration: 300, delay: 0, easing: backIn }}">
	<slot name='header'></slot>
	<slot></slot>
	{#if !cta && !lang && !saved && !salepop}
	<button on:click='{() => dispatch("close")}'>No thanks</button>
	{/if}
	{#if salepop}
	<div class="button-grid">
		<button class="success-cta" on:click='{() => dispatch("close")}'>Great!</button>
		<button class="secondary-cta" on:click='{() => dispatch("ignore")}'>Don't show again</button>
	</div>
	{/if}
	{#if saved}
	<div class="button-grid">
			<button class="success-cta" on:click='{() => dispatch("resume")}'>Re-order / Resume</button>
			<button class="secondary-cta" on:click='{() => dispatch("reset")}'>Start a new order</button>
	</div>
	{/if}
	{#if cta && mstep == 1}
		<div class="button-grid">
			<button class="main-cta" on:click='{() => dispatch("update")}'>Yes, Please</button>
			<button class="secondary-cta" on:click='{() => dispatch("close")}'>No Thanks</button>
		</div>
	{:else if cta && mstep == 2}
		<div class="button-grid">
			<button class="beef-cta" on:click='{() => dispatch("beefup")}'>Beef Lung</button>
			<button class="sweet-cta" on:click='{() => dispatch("sweetup")}'>Sweet Potato</button>
		</div>
	{/if}
	{#if lang}
		<div class="button-grid">
			<button class="country-btn" on:click='{() => dispatch("canada")}'>
				<img src="ca.png" class="country-img" alt="Canadian Flag"/> <span>Canada</span>
			</button>
			<button class="country-btn" on:click='{() => dispatch("usa")}'>
				<img src="us.png" class="country-img" alt="Canadian Flag"/> <span>United States</span>
			</button>
		</div>
		<small>Want Healthybud in your country? Let us know <a class="email-us" target="_blank" href="mailto:yourfriends@healthybud.co?subject=Bring Healthybud to my country!">yourfriends@healthybud.co</a></small>
	{/if}
</div>
